import moment from "moment";
export default {
    namespaced: true,
    state: {
        isLoading: false,
        isLoadingMore: false,
        userActivities: {},

    },
    getters: {
        isLoading: (state) => {
            return state.isLoading
        },
        isLoadingMore: (state) => {
            return state.isLoadingMore
        },
        userActivities: (state) => {
            return state.userActivities
        },
    },
    actions: {
        async getUsersActivities ({ commit }, params) {

            // const loader = params.page > 1 ? 'setIsloadingMore' : 'isLoading';
            commit('setIsLoading', true)

            try {
                const path = `/admin/report/get/user/activities`;

                if (params.date) {
                    params.date = moment(params.date).format("YYYY-MM-DD")
                }

                const response = await axios.get(path, { params })

                if (response && response.success) {
                    commit('setUserActivities', response.data)
                }

            } catch (error) {
                console.warn(error)
            }

            commit('setIsLoading', false)
        }

    },
    mutations: {
        setIsLoading (state, payload) {
            state.isLoading = payload
        },
        setIsLoadingMore (state, payload) {
            state.isLoadingMore = payload
        },
        setUserActivities (state, payload) {
            state.userActivities = payload
        }
    },
}
